import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9d965fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "comhonor" }
const _hoisted_2 = { class: "honortext animate__animated animate__backInDown wow" }
const _hoisted_3 = { class: "honor-list" }
const _hoisted_4 = { class: "bgimg animate__animated animate__backInUp wow" }
const _hoisted_5 = { alt: "" }

import WOW from "wowjs";
import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ComHonor',
  setup(__props) {

onMounted(async () => {
  new WOW.WOW({ live: false }).init();
});

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("Competition")) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("First")), 1)
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("Biopharmaceutical")) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Top 30")), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("Participating")), 1)
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("Finals")) + " “", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Excellent Enterprise")), 1),
          _createTextVNode("”" + _toDisplayString(_ctx.$t("Title")), 1)
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("Be Selected")) + " “", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Maker China")), 1),
          _createTextVNode("”" + _toDisplayString(_ctx.$t("Top 500")), 1)
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("Year 2023")), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Entrepreneurship")), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("Plan")), 1)
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("15th")) + " “", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Double 100")), 1),
          _createTextVNode("”" + _toDisplayString(_ctx.$t("enterprise")), 1)
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("2023won")) + " “", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("highEnter")), 1),
          _createTextVNode("”" + _toDisplayString(_ctx.$t("recognition")), 1)
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("2023wonFJ")) + " “", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("hundredPlan")), 1),
          _createTextVNode("”" + _toDisplayString(_ctx.$t("recognition")), 1)
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("2024get")) + " “", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("FujianB")), 1),
          _createTextVNode("”" + _toDisplayString(_ctx.$t("recognition")), 1)
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("2025get")) + " “", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Dengling")), 1),
          _createTextVNode("” ")
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("2025won")) + " “", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("ZhuanJingTeXinTitle")), 1),
          _createTextVNode("”" + _toDisplayString(_ctx.$t("recognition")), 1)
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("2025won")) + " “", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("TechSMETitle")), 1),
          _createTextVNode("”" + _toDisplayString(_ctx.$t("recognition")), 1)
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(_toDisplayString(_ctx.$t("2026selected")) + " “", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("FutureIndustryTitle")), 1),
          _createTextVNode("” ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
        [_directive_lazy, require('@/assets/honorcombine.jpg')]
      ])
    ])
  ]))
}
}

})